import { toast } from "react-toastify"

const initState = {
    error: null,
    isLoading: false,
    isLoggedIn: false,
    recoverPasswordMessage: null,
}

const authReducer = (state = initState, action) => {
    switch (action.type) {
        case 'IS_LOADING_AUTH':
            return {
                ...state,
                isLoading: true
            }
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isLoggedIn: true,
                isLoading: false
            }
        case 'LOGIN_ERROR':
            toast.error('Aconteceu um erro no login, a senha inserida é invalida e/ou email inserido é invalido.');
            return {
                ...state,
                error: action.payload,
                isLoggedIn: false,
                isLoading: false,
            }
        case 'LOGOUT_SUCCESS':
            return {
                ...state,
                isLoggedIn: false,
                isLoading: false
            }
        case 'LOGOUT_ERROR':
            return {
                ...state,
                isLoggedIn: false,
                isLoading: false,
                error: action.payload
            }
        case 'REGISTER_SUCCESS':
            toast.success('Registo bem sucedido, bem-vindo ao Adventour!');
            return {
                ...state,
                isLoggedIn: true,
                isLoading: false,
            }
        case 'REGISTER_ERROR':
            toast.error(action.error ? action.error : `Ops! Aconteceu um erro no registo, ${action.payload}`)
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            }
        case 'PASSWORD_RESET_EMAIL_SUCCESS':
            toast.success(`Email enviado com sucesso! Verifique a sua caixa de correiro um email que possua uma link para a mudança na senha no adventour.`)
            return {
                ...state,
                isLoading: false,
            }
        case 'PASSWORD_RESET_EMAIL_ERROR':
            toast.error(`Ops! Aconteceu um erro no envio do email para a recuperação da sua senha!`)
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        default:
            return state
    }
}

export default authReducer;